// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"41":"d4602de7","256":"7776520a","351":"a51239df","952":"fe25c6e1"}[chunkId] + ".chunk.css";
};